<mat-card class="column comparison-card">
  <mat-card-header>
    <mat-card-title><img src="icons/id_card.svg" alt="contact info"/> Contact Info</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <mat-radio-group [(ngModel)]="contactType">
        <mat-radio-button [value]="ContactType.OWNER">Owner's Name</mat-radio-button>
        <mat-radio-button [value]="ContactType.COMPANY">Company Name</mat-radio-button>
      </mat-radio-group>
    </div>
    <form *ngIf="contactType === ContactType.OWNER" [formGroup]="ownerForm">

      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>First Name</mat-label>
          <input formControlName="firstName" matInput>
          <mat-error *ngIf="ownerForm.get('firstName')?.hasError('required')">
            First name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Last Name</mat-label>
          <input formControlName="lastName" matInput>
          <mat-error *ngIf="ownerForm.get('lastName')?.hasError('required')">
            Last name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Email Address</mat-label>
          <input formControlName="email" matInput>
          <mat-error *ngIf="ownerForm.get('email')?.hasError('required')">
            Email address is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Phone Number</mat-label>
          <input formControlName="phone" matInput>
          <mat-error *ngIf="ownerForm.get('phone')?.hasError('required')">
            Phone number is required.
          </mat-error>
          <mat-error *ngIf="ownerForm.get('phone')?.hasError('pattern')">
            Please use a valid phone number.
          </mat-error>
        </mat-form-field>
      </div>

    </form>
    <form *ngIf="contactType === ContactType.COMPANY" [formGroup]="companyForm">
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Business Legal Name</mat-label>
          <input formControlName="businessLegalName" matInput>
          <mat-error *ngIf="companyForm.get('businessLegalName')?.hasError('required')">
            Business legal name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Business DBA Name</mat-label>
          <input formControlName="businessDbaName" matInput>
          <mat-error *ngIf="companyForm.get('businessDbaName')?.hasError('required')">
            Business DBA name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Website URL</mat-label>
          <input formControlName="webSiteUrl" matInput>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>

